import { render, staticRenderFns } from "./TranscribeGap.vue?vue&type=template&id=d81ba768&"
import script from "./TranscribeGap.vue?vue&type=script&lang=js&"
export * from "./TranscribeGap.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeGap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports